






























import { Component, PropSync, Vue } from 'vue-property-decorator'

@Component
export default class ReportInfoDialog extends Vue {
  @PropSync('show') active!: boolean;
  @PropSync('propMessageContent') messageContent!: any;

  get isFound() {
    return this.messageContent.duplicates_count
        || this.messageContent.msisdn_and_email_duplicates_count
        || this.messageContent.incorrect_msisdn_count
        || this.messageContent.msisdn_duplicates_count
        || this.messageContent.incorrect_addresses_count
        || this.messageContent.email_duplicates_count
        || this.messageContent.disposable_addresses_count
        || this.messageContent.role_based_addresses_count
        || this.messageContent.inactive_domain_addresses_count
  }

}
